import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { t } from "ttag";
import { getEntityLabel, SyncJob } from "./deviceSyncConfig";

const dialogTitle = (jobs: SyncJob[]) => {
  if (jobs.length !== 1) {
    const count = jobs.length;
    return t`Sync ${count} entities?`;
  }
  return jobs[0].action === "push"
    ? t`☁️➡️📱 Push cloud to device?`
    : t`📱➡️☁️ Pull device to cloud?`;
};

const SyncConfirmDialog = ({
  jobs,
  syncing,
  deviceConnected,
  onCancel,
  onConfirm
}: {
  jobs: SyncJob[] | null;
  syncing: boolean;
  deviceConnected: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  const singleJob = jobs?.length === 1 ? jobs[0] : null;
  const singleTarget = singleJob?.action === "push" ? t`the device` : t`the cloud`;
  const singleLabel = singleJob ? getEntityLabel(singleJob.entity) : "";

  return (
    <Dialog open={!!jobs} onClose={() => !syncing && onCancel()}>
      <DialogTitle>{jobs ? dialogTitle(jobs) : ""}</DialogTitle>
      <DialogContent>
        {singleJob ? (
          <DialogContentText>
            {t`This will overwrite ${singleTarget} ${singleLabel} data.`}
          </DialogContentText>
        ) : (
          <DialogContentText component="div">
            {t`This will overwrite data for:`}
            <Box component="ul" sx={{ mt: 1, pl: 2 }}>
              {(jobs || []).map((job) => (
                <li key={`${job.entity}-${job.action}`}>
                  {getEntityLabel(job.entity)}
                  {job.action === "push" ? t` — cloud → device` : t` — device → cloud`}
                </li>
              ))}
            </Box>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button disabled={syncing} onClick={onCancel}>{t`Cancel`}</Button>
        <Button
          disabled={syncing || !deviceConnected}
          variant="contained"
          onClick={onConfirm}
        >
          {syncing ? t`Syncing…` : t`Confirm`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SyncConfirmDialog;
